import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    privileges: [], // Initially, no privileges are stored
};

const privilegesSlice = createSlice({
    name: "privileges",
    initialState,
    reducers: {
        setPrivileges: (state, action) => {
            state.privileges = action.payload;
        },
        clearPrivileges: (state) => {
            state.privileges = [];
        },
    },
});

export const { setPrivileges, clearPrivileges } = privilegesSlice.actions;
export default privilegesSlice.reducer;
